export const CONSENT_CHANGE_EVENT = "diality:analytics-consent-change";

export const CONSENT_COOKIE = "diality_analytics_consent";

/** null means the visitor has not made a recognized choice yet. */
export function readAnalyticsConsent(cookie: string): boolean | null {
  const value = cookie.split(";").map((part) => part.trim());
  if (value.includes(`${CONSENT_COOKIE}=granted`)) return true;
  if (value.includes(`${CONSENT_COOKIE}=denied`)) return false;
  return null;
}

export function hasAnalyticsConsent(): boolean {
  return readAnalyticsConsent(document.cookie) === true;
}

export function grantAnalyticsConsent(): void {
  document.cookie = `${CONSENT_COOKIE}=granted; Path=/; Max-Age=31536000; SameSite=Lax`;
  window.dispatchEvent(new Event(CONSENT_CHANGE_EVENT));
}

export function denyAnalyticsConsent(): void {
  document.cookie = `${CONSENT_COOKIE}=denied; Path=/; Max-Age=31536000; SameSite=Lax`;
  // Disable the tag before deleting identifiers so it cannot recreate them.
  window.dispatchEvent(new Event(CONSENT_CHANGE_EVENT));
  clearAnalyticsCookies();
}

/** Remove GA's first-party cookies, including parent-domain cookie variants. */
export function clearAnalyticsCookies(): void {
  const names = document.cookie
    .split(";")
    .map((cookie) => cookie.trim().split("=")[0])
    .filter((name) =>
      /^(?:_ga(?:_|$)|_gid$|_gat(?:_|$)|__utm[a-z]+$)/.test(name),
    );
  const domains = [""];
  const parts = window.location.hostname.split(".");
  for (let i = 0; i < parts.length; i++) {
    const domain = parts.slice(i).join(".");
    domains.push(`; Domain=${domain}`, `; Domain=.${domain}`);
  }
  const paths = new Set(["/"]);
  const segments = window.location.pathname.split("/");
  for (let i = 1; i <= segments.length; i++) {
    const path = segments.slice(0, i).join("/") || "/";
    paths.add(path);
    paths.add(path.endsWith("/") ? path : `${path}/`);
  }
  for (const name of names) {
    for (const domain of domains) {
      for (const path of paths) {
        document.cookie = `${name}=; Max-Age=0; Path=${path}${domain}; SameSite=Lax`;
      }
    }
  }
}
